import {useUpmPlant} from '@hconnect/upm'

import {useUrlParam} from '../../../shared/hooks/useUrlParam'

export const usePlantUpmId = () => {
  const plantId = useUrlParam('plantId')
  const upmPlant = useUpmPlant({plantId, shouldRaiseError: true})

  return upmPlant.upmId
}
